import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column flex-xl-row my-10"
}
const _hoisted_2 = { class: "flex-lg-row-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceDefault = _resolveComponent("InvoiceDefault")!

  return (_ctx.invoice && Object.keys(_ctx.invoice).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.invoice)
            ? (_openBlock(), _createBlock(_component_InvoiceDefault, {
                key: 0,
                invoice: _ctx.invoice
              }, null, 8, ["invoice"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}